export const Weblabs = Object.freeze({
    navRedesign: 'VC_NAV_REDESIGN_787351',
});
